import ACTION_TYPES from "../types";

// reducer.js
const INITIAL_STATE = {
	userData: null,
	user:'',
	fullScreen:false,
	setFooter: false,
	allUsers:[],
	myCurrentSession:'',
	authLoading: true,
}

export default (state = INITIAL_STATE, action) => {
	switch(action.type) {
		case ACTION_TYPES.GET_USER:
			return {
			  ...state,
			  userData: action.payload,
			  user: action.payload?.email || '',
			  myCurrentSession: action.payload
				? action.payload.email + '-%^' + new Date()
				: '',
			  authLoading: false, 
			};
		case ACTION_TYPES.SET_FULLSCREEN:
			return {
				...state,
				fullScreen:action.fullScreen
			}
		case ACTION_TYPES.SET_FOOTER_FOR_WORKSPACES:
			return{
				...state,
				setFooter:action.setFooter,
			}
		case ACTION_TYPES.SET_ALL_USERS:
			return{
				...state,
				allUsers:action.allUsers
			}
			case ACTION_TYPES.REMOVE_USER:
				return {
					...state,
					userData: null,
					user:'',
					myCurrentSession:''
				}
				case ACTION_TYPES.SET_AUTH_LOADING:
				return {
					...state,
					authLoading:action.authLoading
				}
		default:
			return state;
	}
};